// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"552581":"lazy-survey","706569":"lazy-jury"}[chunkId] + "." + {"552581":"c1805e50","706569":"dc6d085a"}[chunkId] + ".chunk.css";
};